interface HasStart {
  start: Date;
}

/** The candidate whose start is nearest the cursor's snapped time, first-seen
 *  winning ties (strictly-less-than comparison). `null` with no candidates. */
export function nearestCandidate<T extends HasStart>(candidates: T[], cursor: Date): T | null {
  let best: T | null = null;
  let bestDistance = Number.POSITIVE_INFINITY;
  for (const candidate of candidates) {
    const distance = Math.abs(candidate.start.getTime() - cursor.getTime());
    if (distance < bestDistance) {
      bestDistance = distance;
      best = candidate;
    }
  }
  return best;
}
